module.exports = __webpack_public_path__ + "img/SL-M-180-220.e0dc290f.svg";